import type { RootState } from 'state';

function getCurrentEdit(state: RootState): string | null {
  const { currentEdit } = state.bookings.screensConfig;
  return currentEdit;
}

export default getCurrentEdit;
